import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Logo } from "@/components/Common";
import { api, errMsg } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true, ok: false, error: "" });
  useEffect(() => {
    api.post("/auth/verify-email", { token: params.get("token") || "" })
      .then(() => setState({ loading: false, ok: true, error: "" }))
      .catch((e) => setState({ loading: false, ok: false, error: errMsg(e) }));
  }, [params]);
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="glass glow w-full max-w-md p-8" data-testid="verify-email-page">
        <Logo sub />
        <h1 className="mt-6 text-2xl font-bold text-white">E-Mail-Bestätigung</h1>
        {state.loading && <p className="mt-4 text-slate-400">Prüfe Link…</p>}
        {state.ok && <p className="mt-4 text-emerald-300" data-testid="verify-success">Deine E-Mail-Adresse ist bestätigt.</p>}
        {state.error && <p className="mt-4 text-red-300" data-testid="verify-error">{state.error}</p>}
        <Link to="/app" className="btn-grad mt-6 inline-block px-5 py-2.5" data-testid="verify-continue">Weiter zum Hub</Link>
      </div>
    </div>
  );
}
